// `hsCtaAttrib` is an opaque, user-controlled query value (a HubSpot CTA id).
// Cap its length at this single entry point so a malformed/oversized value can't
// bloat the Google-login redirect URL or the stored HubSpot property. Real values
// are ~12-digit ids, so 255 never touches a legitimate one; defense-in-depth only
// (the backend remains the authoritative validator).
const MAX_HS_CTA_ATTRIB_LENGTH = 255;

export function parseUrlParams(stringUrl: string): {
    productUid: string;
    provider: string;
    errorCode: string;
    hsCtaAttrib: string;
} {
    const url = new URL(stringUrl);
    const params = new URLSearchParams(url.search);

    return {
        productUid: params.get("productUid") || "",
        provider: params.get("provider") || "",
        errorCode: params.get("errorCode") || "",
        hsCtaAttrib: (params.get("hsCtaAttrib") || "").slice(0, MAX_HS_CTA_ATTRIB_LENGTH)
    };
}
